<template>
	<div v-if="isLateNight" class="special special-late">
		<i class="sk-icon-moon-stars-light special-icon" alt="Late Night"></i>
		<div class="special-description">
			<h3 class="special-title">It's Late Night!</h3>
			<h4 class="special-subtitle">Menu items have been adjusted</h4>
		</div>
	</div>
</template>

<script>
export default {
	name: "LateNightBanner",
	computed: {
		isLateNight() {
			const isLateNight = this.$store.getters.inStockMenus.some(
				(menu) => menu.is_late_night
			)
			const isBackup = this.$store.state.backup_mode
			return isLateNight && !isBackup
		}
	}
}
</script>